import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import WebapiCommon from '@common/util/webapi.common';
import * as commonActions from '@common/common.action';
import GridReceptaculos from '../../../controleTarefas/Recptaculos';
import { Badge } from 'reactstrap';
import { colorsSystem } from '@common/util/defaultValues';

function Blocos ({ laudo }) {
  const dispatch = useDispatch();
  const [lista, setLista] = useState([]);
  useEffect(() => {
    laudo && getBlocos(laudo);
  }, [laudo]);

  const formatBloco = bloco => {
    if (bloco.cancelado) {
      if (bloco.nrBloco.includes('CANCELADO')) {
        const nrBloco = bloco.nrBloco.replace('[ CANCELADO ]', '');
        return badgeBlocoCancelado(nrBloco);
      } else {
        return badgeBlocoCancelado(bloco.nrBloco);
      }
    } else {
      return bloco.nrBloco;
    }
  };

  const badgeBlocoCancelado = bloco => {
    return (
      <span>
        {`${bloco} `}
        <Badge
          style={{
            fontSize: '10px',
            backgroundColor: colorsSystem.VERMELHO,
            color: '#fff'
          }}
        >
          CANCELADO
        </Badge>
      </span>
    );
  };

  const getBlocos = laudoId => {
    dispatch(commonActions.showFadeCarregando(true));

    const query = {
      dataIncio: '',
      dataFim: '',
      laudoId,
      exibirCancelados: true
    };
    WebapiCommon.getLaudoBlocosControleReceptaculo(
      query.dataIncio,
      query.dataFim,
      query.laudoId,
      query.exibirCancelados
    ).then(resp => {
      const dataFormated = resp.data.map(item => ({
        ...item,
        nrBloco: formatBloco(item),
        urgencia: item.urgencia ? 'SIM' : 'NÃO',
        novosCortes: item.novosCortes ? 'SIM' : 'NÃO'
      }));
      setLista(dataFormated);
      dispatch(commonActions.showFadeCarregando(false));
    });
  };
  return <GridReceptaculos lista={lista} />;
}

export default Blocos;



// WEBPACK FOOTER //
// ./src/pages/main/ControleBlocosLaminas/Blocos/index.js